<template>
<div class="service-card card mb-2" v-on:click="$emit('click')">
	<div class="card-body">

		<h5 v-if="showStatus" :class="statusClass">{{service.status}}</h5>

		<div class="d-flex justify-content-between align-items-center">
			<h3 class="card-title">
				<div>Service #{{service.job_num}}</div>
				<div><small>Name: <strong v-html="service.job_name"></strong></small></div>
				<div><small>Customer: <strong>{{service.customer_name_cache}}</strong></small></div>
			</h3>
			<div v-if="service.emergencyIcon" class="text-danger text-center">
				<span v-html="service.emergencyIcon"></span>
				Emergency
			</div>
		</div>

		<div class="row">
			<div class="col-sm-6">
				<div class="address">
					<div v-if="'ContactLocation' in service && service.ContactLocation">
						{{service.ContactLocation.location_name}}
					</div>

					<div v-if="service.suite">{{service.suite}}</div>
					{{service.address}}, {{service.city}}
				</div>

				<div class="mt-2">
					<h5 class='label'>Scheduled: </h5>
					<strong v-html="service.scheduledFor"></strong> @ 
					<strong v-html="service.aptTime"></strong>
				</div>
			</div>
			<div class="col-sm-6">

				<div class="mt-2" v-if="service.estimated_time > 0">
					<h5 class='label'>Estimated Time: </h5>
					<strong>{{ service.estimated_time }}</strong> hrs
				</div>

				<div class="mt-2">
					<h5 class="label">Crew Members: </h5>
					<strong>{{service.techList}}</strong>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "ServiceCard",
	props: ["service","showStatus"],
	computed: {
		statusClass() {
			if (this.service.status == 'Dispatched' || this.service.status == '')
				return "text-warning"
			else if (this.service.status == 'Canceled')
				return "text-danger"
			else
				return "text-success"
		}
	}
}
</script>

<style type="text/css" scoped>
	.service-card:hover {
		background-color: #EAE9E7;
		cursor: pointer;
	}

	.card-body h3 {
		text-transform: uppercase;
	}

	.label {
		display: inline;
		text-transform: uppercase;

	}
</style>